import { useContext } from "react";
import styled from "styled-components";
import { StandardShadow } from "./StandardShadow";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { Center } from "./Center";
import { useAppColors } from "../utils/useAppColors";
import { isMobile } from "react-device-detect";
import RuleView2 from "./RuleView2";
import { Web3Context } from "../contexts/Web3Context";

const BondViewWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
  border-top: 2px solid ${(props) => props.borderColor};
  border-left: 2px solid ${(props) => props.borderColor};
  border-bottom: 2px solid ${(props) => props.borderColor};
  border-right: 2px solid ${(props) => props.borderColor};
  border-radius: 24px;
  padding: 20px;
  cursor: pointer;
  background-color: ${(props) => props.backgroundColor};
`;

const RulesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  font-weight: bold;
`;

const MobileRulesWrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  font-weight: bold;
`;

const AndLink = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
`;

const SelectedCircle = styled.div`
  color: ${(props) => props.color};
  border-radius: 5000px;
  padding:2px;
  display:flex;
  align-items;center;
  justify-content:center;
`;
export default function BondView2({
  bond,
  match,
  selected,
  selectBond,
}) {
  const colors = useAppColors();
  const { user, linkSolana, linkEthereum } = useContext(Web3Context);
  const bondClass = match ? "active-gradient-selector" : "";
  const bondBackgroundColor = bond.type == "friend-tech-holder" ? "#96e4ff" : "white";

  // When a signed-in viewer doesn't match a bond and is missing the wallet that
  // bond's chain needs, prompt them to link it (otherwise it's a silent dead end).
  const solanaRuleTypes = ["spl-ownership", "sol-ownership"];
  const isSolanaRule = (t) => solanaRuleTypes.includes(t);
  const isSolanaBond =
    bond.rules && bond.rules.some((r) => isSolanaRule(r.type));
  const isEvmBond =
    bond.rules && bond.rules.some((r) => r.type && !isSolanaRule(r.type));
  const needsSolanaLink =
    user && !match && isSolanaBond && !user.solanaAddress;
  const needsEvmLink = user && !match && isEvmBond && !user.evmAddress;
  return (
    <>
    <StandardShadow borderRadius={"24px"}>
      <BondViewWrapper
        match={match}
        className={bondClass}
        selected={selected}
        borderColor={match ? colors.successGreen : "black"}
        backgroundColor={bondBackgroundColor}
        onClick={() => {
          console.log("bondId:", bond.bondId )
          console.log("bondIndex: ", bond.bondIndex)
          selectBond({
            bondId: bond.bondId,
            bondIndex: bond.bondIndex,
            match: match,
            isSolana: isSolanaBond,
          });
        }}
      >
        {isMobile ? (
          <>
            <MobileRulesWrapper>
              {bond.rules.map((r, ruleIndex) => (
                <>
                  <RuleView2
                    key={"bond-" + bond.bondId + "-rule-" + r._id + "p"}
                    rule={r}
                    isMobile={isMobile}
                  />
                </>
              ))}
            </MobileRulesWrapper>
          </>
        ) : (
          <>
            <RulesWrapper>
              {bond.rules.map((r, ruleIndex) => (
                <RuleView2
                  key={"bond-" + bond.bondId + "-rule-" + r._id}
                  rule={r}
                  isMobile={isMobile}
                />
              ))}
              <>
                {bond.rules.length > 1 && (
                  <AndLink key={"bond-" + bond.bondId + "-rule-link"}>
                  🔗
                  </AndLink>
                )}
              </>
            </RulesWrapper>
          </>
        )}
        {selected ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SelectedCircle
              className="lighter-active-gradient"
              color={colors.primaryColor}
            >
              <BsFillCheckCircleFill size={20} />
            </SelectedCircle>
          </div>
        ) : null}
      </BondViewWrapper>
    </StandardShadow>
    {(needsSolanaLink || needsEvmLink) && (
      <div
        onClick={(e) => {
          e.stopPropagation();
          if (needsSolanaLink) {
            linkSolana();
          } else {
            linkEthereum();
          }
        }}
        style={{
          cursor: "pointer",
          marginTop: "6px",
          fontSize: "13px",
          fontWeight: "bold",
          color: colors.primaryColor,
          textAlign: "center",
        }}
      >
        {needsSolanaLink
          ? "🔗 Link a Solana wallet to qualify for this bond"
          : "🔗 Link an Ethereum wallet to qualify for this bond"}
      </div>
    )}
    </>
  );
}